import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  createAndUpdatePointsServer,
  getPointsServer,
} from "../../../apis/pointsApis";
import { useNavigate, useParams } from "react-router-dom";
import { pointsScheme } from "../../../Validations/pointsValidations";

export default function AddCoins() {
  const [loading, setLoading] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [addPointsInitial, setAddPointsInitial] = useState({
    actionName: "",
    description: "",
    rewardPoints: "",
  });
  const { id } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      editPoints();
    }
  }, [id]);
  const editPoints = async () => {
    setEditLoader(true);
    try {
      const res = await getPointsServer(id);
      let result = res.result;
      if (result) {
        setAddPointsInitial({
          actionName: res.result.actionName,
          description: res.result.description,
          rewardPoints: res.result.rewardPoints,
        });
        setEditLoader(false);
      }
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: addPointsInitial,
    enableReinitialize: true,
    validationSchema: pointsScheme,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        let res;
        res = id
          ? await createAndUpdatePointsServer(id, { ...values, id })
          : await createAndUpdatePointsServer(id, values);

        setLoading(false);
        formik.resetForm();
        navigate("/points");
      } catch (error) {
        console.error("Error submitting form:", error);
        throw error;
      }
    },
  });
  const backClick = () => {
    navigate("/points");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            {" "}
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              {editLoader ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Action Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="actionName"
                      value={formik.values.actionName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.actionName && formik.touched.actionName && (
                      <span className="text-danger">
                        {formik.errors.actionName}
                      </span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Description <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.description &&
                      formik.touched.description && (
                        <span className="text-danger">
                          {formik.errors.description}
                        </span>
                      )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      rewardPoints <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="rewardPoints"
                      value={formik.values.rewardPoints}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.rewardPoints &&
                      formik.touched.rewardPoints && (
                        <span className="text-danger">
                          {formik.errors.rewardPoints}
                        </span>
                      )}
                  </div>

                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className="btn btn-primary" type="submit">
                      {id ? "Update" : "Submit"}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
